import React from "react";
import { Skeleton } from "@heroui/skeleton";

const ChartSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Skeleton className="h-72 w-64 mb-4" /> {/* Placeholder for the chart */}
      <Skeleton className="h-10 w-48 rounded-lg" />{" "}
      {/* Placeholder for the button */}
    </div>
  );
};
export default ChartSkeleton;
